<template>
  <div>
    <div class="cr-bg-white-1 cr-p-2 box-shadow">
      <h1 class="cr-fs-lg cr-text-black-1 fw-bold">发票管理</h1>
      <a-row :gutter="20" class="page-top-card cr-fs-md cr-mt-2">
        <a-col :span="8">
          <div class="card">
            <div class="title cr-text-grey-2">待开票金额</div>
            <div class="cr-text-black-1 money cr-jc-between">
              <div class="cr-ai-center">
                ￥<span>{{ invoiceNotTotalAmount.toFixed(2) }}</span>
              </div>
              <a-button type="primary" @click="handleApply('all')">申请发票</a-button>
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="card">
            <div class="title cr-text-grey-2">已开票金额</div>
            <div class="cr-text-black-1 money">
              ￥<span>{{ totalAmount.toFixed(2) }}</span>
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="card">
            <div class="cr-jc-between">
              <span class="title cr-text-grey-2">发票抬头</span>
              <a @click="invoiceVisible = true">{{ invoiceTotal.title ? '修改' : '添加发票抬头' }}</a>
            </div>
            <a-tooltip placement="bottomLeft" :getPopupContainer="(e) => e.parentNode" v-if="invoiceTotal.title">
              <template slot="title">
                <div>
                  <label class="cr-text-grey-1 cr-text-lt cr-in-block">发票抬头</label>
                  <span class="cr-text-black-1">{{ invoiceTotal.title || '-' }}</span>
                </div>
                <div>
                  <label class="cr-text-grey-1 cr-text-lt cr-in-block">纳税号</label>
                  <span class="cr-text-black-1">{{ invoiceTotal.identifyNo || '-' }}</span>
                </div>
                <div>
                  <label class="cr-text-grey-1 cr-text-lt cr-in-block">公司地址</label>
                  <span class="cr-text-black-1">{{ invoiceTotal.address || '-' }}</span>
                </div>
                <div>
                  <label class="cr-text-grey-1 cr-text-lt cr-in-block">公司电话</label>
                  <span class="cr-text-black-1">{{ invoiceTotal.mobile || '-' }}</span>
                </div>
                <div>
                  <label class="cr-text-grey-1 cr-text-lt cr-in-block">开户银行</label>
                  <span class="cr-text-black-1">{{ invoiceTotal.accountBank || '-' }}</span>
                </div>
                <div>
                  <label class="cr-text-grey-1 cr-text-lt cr-in-block">开户账户</label>
                  <span class="cr-text-black-1">{{ invoiceTotal.accountNo || '-' }}</span>
                </div>
              </template>
              <div class="cr-text-black-1 cr-mt-3 invoice cr-cursor cr-in-block">
                {{ `${invoiceTotal.title}（${invoiceTotal.identifyNo})` }}
              </div>
            </a-tooltip>
            <div class="cr-mt-3 invoice cr-text-6" v-else>暂无发票信息</div>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="cr-bg-white-1 cr-p-2 cr-mt-1 box-shadow widtn-190">
      <!-- 搜索框 -->
      <a-radio-group :value="status" @change="handleStatusChange">
        <a-radio-button :value="10"> 待申请 </a-radio-button>
        <a-radio-button :value="20"> 申请中 </a-radio-button>
        <a-radio-button :value="40"> 申请失败 </a-radio-button>
        <a-radio-button :value="30"> 已开票 </a-radio-button>
      </a-radio-group>
      <!-- 表单 -->
      <a-form-model layout="horizontal" class="cr-mt-3 form-box">
        <a-row :gutter="24">
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
            <a-form-model-item label="业务类型">
              <a-select v-model="formData.coprType" @change="handleTypeChange" placeholder="请选择" allowClear>
                <a-select-option v-for="item of businessTypeList" :key="item.code" :value="item.code"> {{ item.fullDesc }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-show="status == 10">
            <a-form-model-item label="名称">
              <a-input placeholder="请输入" v-model="formData.shortName" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-show="status == 10">
            <a-form-model-item label="支付时间">
              <a-date-picker @change="handleChangePayDate" :value="formData.payBeginTime ? moment(formData.payBeginTime, 'YYYY-MM-DD') : null" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-show="status == 10">
            <a-form-model-item label="操作人">
              <a-input placeholder="请输入" v-model="formData.opUserName" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-show="status == 20 || status == 30 || status == 40">
            <a-form-model-item label="发票抬头">
              <a-input placeholder="请输入" v-model="formData.title" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-show="status == 20 || status == 40">
            <a-form-model-item label="申请时间">
              <a-date-picker @change="handleChangeApplyDate" :value="formData.applyBeginTime ? moment(formData.applyBeginTime, 'YYYY-MM-DD') : null" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-show="status == 30">
            <a-form-model-item label="开票时间">
              <a-date-picker @change="handleChangeInvoicingDate" :value="formData.openBeginTime ? moment(formData.openBeginTime, 'YYYY-MM-DD') : null" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-show="status == 20 || status == 30 || status == 40">
            <a-form-model-item label="纳税号">
              <a-input placeholder="请输入" v-model="formData.identifyNo" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-show="status == 20 || status == 30 || status == 40">
            <a-form-model-item label="申请编号">
              <a-input placeholder="请输入" v-model="formData.invoiceNo" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
            <a-form-model-item label="案件编号">
              <a-input placeholder="请输入" v-model="formData.caseNo" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
            <a-form-model-item>
              <a-button @click="handleReset"> 重置 </a-button>
              <a-button type="primary" @click="handleSearch" class="margin-left-14"> 搜索 </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <!-- 列表 -->
      <a-table :scroll="{ x: 1300 }" class="cr-mt-2" @change="handleTableChange" :columns="columnsData" :data-source="tableData" :row-key="(record, index) => index" :pagination="pagination" :loading="loading" :locale="{ emptyText: tebleEmptyText }" :row-selection="status == '10' ? { selectedRowKeys: selectedRowKeys, onChange: onSelectChange } : null">
        <span slot="status" slot-scope="text, record">
          {{ record.invoiceState | parseStatus }}
        </span>
        <span slot="payAmount" slot-scope="text, record">
          {{ record | parsePayMethod }}
          <!-- {{ `${record.payAmount.toFixed(2)}/`+(record.paidMethod | parsePayMethod) }} -->
        </span>
        <span slot="amount" slot-scope="text, record">
          {{ record.amount.toFixed(2) }}
        </span>

        <span slot="type" slot-scope="text, record">
          {{ record.type == 0 ? '技术服务费' : '服务费' }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a class="cr-mr-2" @click="handleApply(record)" v-show="status == 10">申请发票</a>
          <a class="cr-mr-2" @click="handleApplyDetail(record)" v-show="status == 20 || status == 30 || status == 40">申请详情</a>
          <a class="cr-mr-2" @click="handleBillDetail(record)" v-show="status == 30">查看发票</a>
          <a @click="handleApplyAgain(record)" v-show="status == 40">再次申请</a>
        </span>
      </a-table>
      <!-- 编辑发票 -->
      <InvoiceModel :isVisible.sync="invoiceVisible" :invoiceInfo="invoiceTotal" @refresh="getInvoiceInfo" />
      <!-- 申请发票弹窗  -->
      <ApplyBillModel :isVisible.sync="applyBillVisible" :invoiceInfo="invoiceInfo" @refresh="refreshData" />
      <!-- 查看发票弹窗 -->
      <BillDetailModel :isVisible.sync="billDetailVisible" :invoiceUrl="invoiceUrl" />
      <!-- 查看申请详情弹窗 -->
      <ApplyDetailModel :isVisible.sync="applyDetailVisible" :detailInfo="applyDetailInfo" />
    </div>
    <!-- 底部申请组件 -->
    <ApplyBottomModel :isVisible.sync="applyBottomVisible" :totalMoney="applyAmount" :orderNum="selectedRowKeys.length" @onAplly="handleApply('select')" />
  </div>
</template>

<script>
import InvoiceModel from './components/invoiceModel'
import ApplyBillModel from './components/applyBillModel'
import BillDetailModel from './components/billDetailModel'
import ApplyDetailModel from './components/applyDetailModel'
import ApplyBottomModel from './components/applyBottomModel'
import { getInvoiceTotal, getTotalAmount, getInvoiceList, getCoprType } from '@/api/billManage'
import moment from 'moment'

const columns1 = [
  {
    title: '序号',
    customRender: (text, record, index) => index + 1,
    width: 80,
    fixed: 'left'
  },
  {
    title: '案件编号',
    dataIndex: 'caseNo',
    width: 220
  },
  {
    title: '业务类型',
    dataIndex: 'coprType',
    width: 150
  },
  {
    title: '操作人',
    dataIndex: 'userName',
    width: 100
  },
  {
    title: '金额/支付方式',
    dataIndex: 'payAmount',
    scopedSlots: { customRender: 'payAmount' },
    width: 200
  },
  {
    title: '支付时间',
    dataIndex: 'payTime',
    width: 180
  },
  {
    title: '开票状态',
    dataIndex: 'invoiceState',
    scopedSlots: { customRender: 'status' },
    width: 100
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: 200,
    fixed: 'right'
  }
]
const columns2 = [
  {
    title: '申请编号',
    dataIndex: 'invoiceNo',
    width: 220
  },
  {
    title: '发票类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
    width: 100
  },
  {
    title: '抬头',
    dataIndex: 'title',
    width: 220
  },
  {
    title: '纳税号',
    dataIndex: 'identifyNo',
    width: 220
  },
  {
    title: '开票金额',
    dataIndex: 'amount',
    scopedSlots: { customRender: 'amount' },
    width: 100
  },
  {
    title: '金额',
    dataIndex: 'amount',
    scopedSlots: { customRender: 'amount' },
    width: 100
  },
  {
    title: '申请时间',
    dataIndex: 'applyTime',
    width: 180
  },
  {
    title: '开票时间',
    dataIndex: 'openInvoiceTime',
    width: 180
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: 200,
    fixed: 'right'
  }
]
export default {
  components: {
    InvoiceModel,
    BillDetailModel,
    ApplyDetailModel,
    ApplyBottomModel,
    ApplyBillModel
  },
  data() {
    return {
      status: 10,
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共${total}条`,
        size: 'small'
      },
      loading: false,
      columns1,
      columns2,
      selectedRowKeys: [],
      invoiceVisible: false,
      applyBillVisible: false,
      invoiceInfo: {}, // 申请发票信息
      billDetailVisible: false,
      invoiceUrl: '', // 发票图片地址
      applyDetailVisible: false,
      applyDetailInfo: {}, // 申请详情
      applyBottomVisible: false,
      tebleEmptyText: <cr-nodata dataHeight="200px" />, // table空状态
      invoiceTotal: {}, // 发票抬头
      invoiceNotTotalAmount: 0, //未开票总金额
      totalAmount: 0, // 开票总金额
      formData: {
        type: '', //发票类型
        title: '', //发票抬头
        opUserName: '', //操作人
        invoiceNo: '', // 发票编号申请编号
        identifyNo: '', // 纳税号
        payBeginTime: '', // 支付开始时间
        payEndTime: '', // 支付结束时间
        openBeginTime: '', // 开票开始时间
        openEndTime: '', // 开票结束时间
        applyBeginTime: '', // 申请开始时间
        applyEndTime: '', // 申请结算时间
        shortName: '', //名称
        coprType: undefined, //业务类型
        caseNo: ''
      },
      payDate: '',
      applyBillIdList: [], //申请发票id列表-多选时
      applyAmount: 0, //申请金额-多选时
      businessTypeList: [], //业务类型
      initFormData: {} // 初始化数据
    }
  },
  created() {
    this.initFormData = { ...this.formData }
    this.getBusinessType()
    this.getInvoiceInfo()
    this.getAmountInfo()
    // this.getListData()
  },
  computed: {
    columnsData() {
      if (this.status == 10) {
        return columns1
      } else if (this.status == 30) {
        return columns2.filter((columns2) => columns2.title !== '开票金额' && columns2.title !== '申请时间')
      } else {
        return columns2.filter((columns2) => columns2.title !== '金额' && columns2.title !== '开票时间')
      }
    }
  },
  filters: {
    // 格式化开票状态
    parseStatus(val) {
      const statusList = {
        10: '待申请',
        20: '申请中',
        30: '已开票',
        40: '申请失败'
      }
      return statusList[val]
    },
    //格式化支付方式
    parsePayMethod(record) {
      const payMethodList = {
        wechat_qr: '微信扫码',
        alipay_qr: '支付宝扫码',
        gateway_pub: '网银支付_对公',
        gateway_pri: '网银支付_对私',
        balance_pay: '余额支付',
        init_sync: '期初同步'
      }
      return record.payAmount.toFixed(2) + '(' + payMethodList[record.paidMethod] + ')'
    }
  },
  methods: {
    moment,
    // 获取发票抬头
    async getInvoiceInfo() {
      let result = await getInvoiceTotal()
      if (result.code == 0) {
        this.invoiceTotal = result.data.length > 0 ? result.data[0] : {}
      }
    },

    // 获取开票金额信息
    async getAmountInfo() {
      let result = await getTotalAmount()
      if (result.code == 0) {
        this.invoiceNotTotalAmount = result.data.invoiceNotTotalAmount / 100
        this.totalAmount = result.data.totalAmount
      }
    },

    // 获取列表数据
    async getListData() {
      this.loading = true
      let params = {
        invoiceStateEnum: this.status,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.formData
      }
      let result = await getInvoiceList(params).catch(() => {
        this.loading = false
      })
      this.loading = false
      if (result.code == 0) {
        this.tableData = this.status == 10 ? result.data.waitInvoice.list : result.data.hbInvoice.list
        // 处理业务类型
        this.tableData.map((item) => {
          item.coprType = this.parseCoprType(item.coprType)
        })
        this.pagination.total = this.status == 10 ? result.data.waitInvoice.total : result.data.hbInvoice.total
      }
    },

    // 获取业务类型
    async getBusinessType() {
      let params = {
        dictName: 'CoprType',
        fields: ['code', 'desc', 'fullDesc']
      }
      let result = await getCoprType(params)
      if (result.code == 0) {
        this.getListData()
        this.businessTypeList = result.data
      }
    },

    // 翻页
    handleTableChange(page) {
      this.pagination = {
        ...page
      }
      this.getListData()
    },

    // 点击选择支付时间
    handleChangePayDate(date, dateString) {
      this.formData.payBeginTime = dateString ? dateString + ' 00:00:00' : ''
      this.formData.payEndTime = dateString ? dateString + ' 23:59:59' : ''
    },
    // 点击选择申请时间
    handleChangeApplyDate(date, dateString) {
      this.formData.applyBeginTime = dateString ? dateString + ' 00:00:00' : ''
      this.formData.applyEndTime = dateString ? dateString + ' 23:59:59' : ''
    },
    // 点击选择开票时间
    handleChangeInvoicingDate(date, dateString) {
      this.formData.openBeginTime = dateString ? dateString + ' 00:00:00' : ''
      this.formData.openEndTime = dateString ? dateString + ' 23:59:59' : ''
    },

    // 刷新数据
    refreshData() {
      this.formData = { ...this.initFormData }
      this.pagination.current = 1
      this.selectedRowKeys = []
      this.applyBottomVisible = false
      this.getAmountInfo()
      this.getListData()
    },

    // 点击搜索
    handleSearch() {
      this.pagination.current = 1
      this.selectedRowKeys = []
      this.applyBottomVisible = false
      this.tableData = []
      this.getListData()
    },

    // 点击重置
    handleReset() {
      this.formData = { ...this.initFormData }
      this.pagination.current = 1
      this.getListData()
    },

    handleStatusChange(e) {
      this.status = e.target.value
      this.tableData = []
      this.formData = { ...this.initFormData }
      this.pagination.current = 1
      this.selectedRowKeys = []
      this.applyBottomVisible = false
      this.getListData()
    },

    // 选择业务类型
    handleTypeChange(e) {},

    // 申请开票 e-(all-全部，select-多选)
    handleApply(e) {
      this.invoiceInfo = {
        ...this.invoiceTotal,
        applyBillIdList: e == 'all' ? ['ALL'] : e == 'select' ? this.applyBillIdList : [e.caseNo],
        applyAmount: e == 'all' ? this.invoiceNotTotalAmount : e == 'select' ? this.applyAmount : e.payAmount
      }
      this.invoiceInfo.applyAmount ? (this.applyBillVisible = true) : this.$message.warning('暂无可开票数据!')
    },

    // 再次申请
    handleApplyAgain(e) {
      this.invoiceInfo = {
        ...e,
        applyBillIdList: [],
        applyAmount: e.amount
      }
      e.excelVo.data.map((item) => {
        this.invoiceInfo.applyBillIdList.push(item[0])
      })
      this.applyBillVisible = true
    },

    // 选择开票
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.applyBillIdList = []
      this.applyAmount = 0
      selectedRowKeys.map((item) => {
        this.applyBillIdList.push(this.tableData[item].caseNo)
        this.applyAmount = this.applyAmount + this.tableData[item].payAmount
      })
      selectedRowKeys.length > 0 ? (this.applyBottomVisible = true) : (this.applyBottomVisible = false)
    },

    // 申请详情
    handleApplyDetail(e) {
      this.applyDetailVisible = true
      this.applyDetailInfo = e
    },

    // 查看发票
    handleBillDetail(e) {
      this.billDetailVisible = true
      this.invoiceUrl = e.invoiceUrl
    },

    // 格式化业务类型
    parseCoprType(type) {
      for (const key in this.businessTypeList) {
        if (this.businessTypeList[key].code == type) {
          return this.businessTypeList[key].fullDesc
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.box-shadow {
  box-shadow: 0px 2px 9px 0px rgba(249, 249, 249, 0.5);
}
.fw-bold {
  font-weight: bold !important;
}
.page-top-card {
  .card {
    height: 100px;
    background: @item-selected;
    padding: 16px;
    .title {
      height: 14px;
    }
    .money {
      font-size: 17px;
      margin-top: 22px;
      font-weight: bold;
      span {
        font-size: 24px;
      }
    }
    .add-button {
      height: 14px;
      text-decoration: underline;
    }
    .invoice {
      font-weight: bold;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    ::v-deep .ant-tooltip {
      width: 365px;
      max-width: 365px;
      height: 189px;
    }
    ::v-deep.ant-tooltip-inner {
      background: @cr-text-f;
      padding: 8px 15px 20px 15px;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      border: none !important;
      width: unset !important;
      height: unset !important;
      > div {
        margin-top: 12px;
        height: 14px;
        line-height: 14px;
      }
      label {
        width: 56px;
        margin-right: 24px;
      }
    }
    ::v-deep.ant-tooltip-arrow::before {
      display: block;
      background-color: @cr-text-f !important;
      width: 10px;
      height: 10px;
    }
    .invoice-title {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
::v-deep.ant-btn {
  border-radius: 2px !important;
}
.margin-left-14 {
  margin-left: 14px;
}
.widtn-190 {
  min-height: calc(100vh - 278px);
  .form-box {
    ::v-deep.ant-input,
    ::v-deep.ant-select-selection {
      border-radius: 2px;
    }
    ::v-deep.ant-calendar-picker {
      width: 100%;
    }
    ::v-deep.ant-form-item {
      margin-bottom: 8px;
      display: flex;
    }
    ::v-deep.ant-form-item label {
      width: 70px;
      display: inline-block;
    }
    ::v-deep.ant-form-item-control-wrapper {
      flex: 1;
      // min-width: 190px;
    }
  }
  ::v-deep.ant-spin {
    color: @theme-color;
  }
  ::v-deep.ant-spin-dot-item {
    background-color: @theme-color;
  }
  ::v-deep.ant-radio-button-wrapper {
    width: 124px;
    padding: 0;
    text-align: center;
    border: 1px solid #dedede;
    color: #333;
    &:not(:first-child) {
      border-left: none;
    }
  }
  ::v-deep.ant-radio-button-wrapper-checked {
    background: @theme-color !important;
    color: @cr-text-f !important;
  }
  ::v-deep.ant-radio-button-wrapper:first-child {
    border: 1px solid #dedede;
    border-radius: 3px 0 0 3px;
  }
  ::v-deep.ant-radio-button-wrapper:last-child {
    border-radius: 0 3px 3px 0;
  }
  ::v-deep.ant-table-thead > tr > th,
  ::v-deep.ant-table-tbody > tr > td {
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    color: @cr-text-3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep.ant-table-thead > tr > th {
    font-weight: bold;
  }
  ::v-deep.ant-table-placeholder {
    border-bottom: none;
  }
  // ::v-deep.ant-pagination-item-active a {
  //   border: 1px solid #47ba90 !important;
  //   border-radius: 2px;
  // }
}
</style>
